import { render, staticRenderFns } from "./BidWritingPage.vue?vue&type=template&id=f04be29a&"
import script from "./BidWritingPage.vue?vue&type=script&lang=js&"
export * from "./BidWritingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports